// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

import {
  AimOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  ArrowsAltOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  BarsOutlined,
  BellOutlined,
  BlockOutlined,
  BranchesOutlined,
  BookOutlined,
  BuildOutlined,
  BulbOutlined,
  BugOutlined,
  CalendarOutlined,
  CameraOutlined,
  CaretDownOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  CheckCircleOutlined,
  CheckCircleTwoTone,
  CheckOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseCircleTwoTone,
  CloseOutlined,
  CloudDownloadOutlined,
  CloudOutlined,
  CloudServerOutlined,
  CloudUploadOutlined,
  ClusterOutlined,
  CodeOutlined,
  CompassOutlined,
  ControlOutlined,
  CopyOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DeleteTwoTone,
  DeploymentUnitOutlined,
  DesktopOutlined,
  DisconnectOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DownOutlined,
  DownloadOutlined,
  DiffOutlined,
  DragOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExceptionOutlined,
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  FilterOutlined,
  FilterTwoTone,
  FireOutlined,
  FlagOutlined,
  FolderAddOutlined,
  FolderOutlined,
  ForkOutlined,
  FormOutlined,
  ForwardOutlined,
  FullscreenOutlined,
  FunnelPlotOutlined,
  GatewayOutlined,
  GithubOutlined,
  GlobalOutlined,
  GoldOutlined,
  GoogleOutlined,
  HddOutlined,
  HomeOutlined,
  IdcardOutlined,
  ImportOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  InteractionOutlined,
  KeyOutlined,
  LinkOutlined,
  LoadingOutlined,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MailOutlined,
  MedicineBoxOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MessageFilled,
  MessageOutlined,
  MinusCircleOutlined,
  MinusOutlined,
  MinusSquareOutlined,
  MobileOutlined,
  MoreOutlined,
  NodeIndexOutlined,
  NotificationOutlined,
  NumberOutlined,
  LaptopOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  PauseCircleOutlined,
  PictureOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  PlusSquareOutlined,
  PoweroffOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  ReconciliationOutlined,
  RedoOutlined,
  ReloadOutlined,
  RetweetOutlined,
  RightCircleOutlined,
  RightSquareOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  SaveOutlined,
  ScheduleOutlined,
  ScissorOutlined,
  ScanOutlined,
  SearchOutlined,
  SettingOutlined,
  ShareAltOutlined,
  ShoppingOutlined,
  StopOutlined,
  SwapOutlined,
  SyncOutlined,
  TagOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  TranslationOutlined,
  UndoOutlined,
  UsbOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UsergroupDeleteOutlined,
  UserOutlined,
  UserSwitchOutlined,
  UploadOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined,
  WarningOutlined,
  WifiOutlined,
  SolutionOutlined
} from '@ant-design/icons-vue'
import renderIcon from '@/utils/renderIcon'

export default {
  install: (app) => {
    app.component('AimOutlined', AimOutlined)
    app.component('ApartmentOutlined', ApartmentOutlined)
    app.component('ApiOutlined', ApiOutlined)
    app.component('AppstoreOutlined', AppstoreOutlined)
    app.component('ArrowDownOutlined', ArrowDownOutlined)
    app.component('ArrowUpOutlined', ArrowUpOutlined)
    app.component('ArrowsAltOutlined', ArrowsAltOutlined)
    app.component('AuditOutlined', AuditOutlined)
    app.component('BankOutlined', BankOutlined)
    app.component('BarChartOutlined', BarChartOutlined)
    app.component('BarcodeOutlined', BarcodeOutlined)
    app.component('BarsOutlined', BarsOutlined)
    app.component('BellOutlined', BellOutlined)
    app.component('BlockOutlined', BlockOutlined)
    app.component('BranchesOutlined', BranchesOutlined)
    app.component('BookOutlined', BookOutlined)
    app.component('BuildOutlined', BuildOutlined)
    app.component('BulbOutlined', BulbOutlined)
    app.component('BugOutlined', BugOutlined)
    app.component('CalendarOutlined', CalendarOutlined)
    app.component('CameraOutlined', CameraOutlined)
    app.component('CaretDownOutlined', CaretDownOutlined)
    app.component('CaretRightOutlined', CaretRightOutlined)
    app.component('CaretUpOutlined', CaretUpOutlined)
    app.component('CheckCircleOutlined', CheckCircleOutlined)
    app.component('CheckCircleTwoTone', CheckCircleTwoTone)
    app.component('CheckOutlined', CheckOutlined)
    app.component('CheckSquareOutlined', CheckSquareOutlined)
    app.component('ClockCircleOutlined', ClockCircleOutlined)
    app.component('CloseCircleOutlined', CloseCircleOutlined)
    app.component('CloseCircleTwoTone', CloseCircleTwoTone)
    app.component('CloseOutlined', CloseOutlined)
    app.component('CloudDownloadOutlined', CloudDownloadOutlined)
    app.component('CloudOutlined', CloudOutlined)
    app.component('CloudServerOutlined', CloudServerOutlined)
    app.component('CloudUploadOutlined', CloudUploadOutlined)
    app.component('ClusterOutlined', ClusterOutlined)
    app.component('CodeOutlined', CodeOutlined)
    app.component('ControlOutlined', ControlOutlined)
    app.component('CompassOutlined', CompassOutlined)
    app.component('CopyOutlined', CopyOutlined)
    app.component('CreditCardOutlined', CreditCardOutlined)
    app.component('DashboardOutlined', DashboardOutlined)
    app.component('DatabaseOutlined', DatabaseOutlined)
    app.component('DeleteOutlined', DeleteOutlined)
    app.component('DeleteTwoTone', DeleteTwoTone)
    app.component('DeploymentUnitOutlined', DeploymentUnitOutlined)
    app.component('DesktopOutlined', DesktopOutlined)
    app.component('DisconnectOutlined', DisconnectOutlined)
    app.component('DoubleLeftOutlined', DoubleLeftOutlined)
    app.component('DoubleRightOutlined', DoubleRightOutlined)
    app.component('DownOutlined', DownOutlined)
    app.component('DownloadOutlined', DownloadOutlined)
    app.component('DiffOutlined', DiffOutlined)
    app.component('DragOutlined', DragOutlined)
    app.component('EditOutlined', EditOutlined)
    app.component('EnvironmentOutlined', EnvironmentOutlined)
    app.component('ExceptionOutlined', ExceptionOutlined)
    app.component('ExclamationCircleOutlined', ExclamationCircleOutlined)
    app.component('EyeInvisibleOutlined', EyeInvisibleOutlined)
    app.component('EyeOutlined', EyeOutlined)
    app.component('FieldTimeOutlined', FieldTimeOutlined)
    app.component('FileDoneOutlined', FileDoneOutlined)
    app.component('FileProtectOutlined', FileProtectOutlined)
    app.component('FilterOutlined', FilterOutlined)
    app.component('FilterTwoTone', FilterTwoTone)
    app.component('FireOutlined', FireOutlined)
    app.component('FlagOutlined', FlagOutlined)
    app.component('FolderAddOutlined', FolderAddOutlined)
    app.component('FolderOutlined', FolderOutlined)
    app.component('ForkOutlined', ForkOutlined)
    app.component('FormOutlined', FormOutlined)
    app.component('ForwardOutlined', ForwardOutlined)
    app.component('FullscreenOutlined', FullscreenOutlined)
    app.component('FunnelPlotOutlined', FunnelPlotOutlined)
    app.component('GatewayOutlined', GatewayOutlined)
    app.component('GithubOutlined', GithubOutlined)
    app.component('GlobalOutlined', GlobalOutlined)
    app.component('GoldOutlined', GoldOutlined)
    app.component('GoogleOutlined', GoogleOutlined)
    app.component('HddOutlined', HddOutlined)
    app.component('HomeOutlined', HomeOutlined)
    app.component('IdcardOutlined', IdcardOutlined)
    app.component('ImportOutlined', ImportOutlined)
    app.component('InboxOutlined', InboxOutlined)
    app.component('InfoCircleOutlined', InfoCircleOutlined)
    app.component('InteractionOutlined', InteractionOutlined)
    app.component('KeyOutlined', KeyOutlined)
    app.component('LinkOutlined', LinkOutlined)
    app.component('LoadingOutlined', LoadingOutlined)
    app.component('LockOutlined', LockOutlined)
    app.component('LoginOutlined', LoginOutlined)
    app.component('LogoutOutlined', LogoutOutlined)
    app.component('MailOutlined', MailOutlined)
    app.component('MedicineBoxOutlined', MedicineBoxOutlined)
    app.component('MenuFoldOutlined', MenuFoldOutlined)
    app.component('MenuUnfoldOutlined', MenuUnfoldOutlined)
    app.component('MessageFilled', MessageFilled)
    app.component('MessageOutlined', MessageOutlined)
    app.component('MinusCircleOutlined', MinusCircleOutlined)
    app.component('MinusOutlined', MinusOutlined)
    app.component('MinusSquareOutlined', MinusSquareOutlined)
    app.component('MobileOutlined', MobileOutlined)
    app.component('MoreOutlined', MoreOutlined)
    app.component('NodeIndexOutlined', NodeIndexOutlined)
    app.component('NotificationOutlined', NotificationOutlined)
    app.component('NumberOutlined', NumberOutlined)
    app.component('LaptopOutlined', LaptopOutlined)
    app.component('OrderedListOutlined', OrderedListOutlined)
    app.component('PaperClipOutlined', PaperClipOutlined)
    app.component('PauseCircleOutlined', PauseCircleOutlined)
    app.component('PictureOutlined', PictureOutlined)
    app.component('PieChartOutlined', PieChartOutlined)
    app.component('PlayCircleOutlined', PlayCircleOutlined)
    app.component('PlusCircleOutlined', PlusCircleOutlined)
    app.component('PlusOutlined', PlusOutlined)
    app.component('PlusSquareOutlined', PlusSquareOutlined)
    app.component('PoweroffOutlined', PoweroffOutlined)
    app.component('ProjectOutlined', ProjectOutlined)
    app.component('QuestionCircleOutlined', QuestionCircleOutlined)
    app.component('ReadOutlined', ReadOutlined)
    app.component('ReconciliationOutlined', ReconciliationOutlined)
    app.component('RedoOutlined', RedoOutlined)
    app.component('ReloadOutlined', ReloadOutlined)
    app.component('RetweetOutlined', RetweetOutlined)
    app.component('RightCircleOutlined', RightCircleOutlined)
    app.component('RightSquareOutlined', RightSquareOutlined)
    app.component('RocketOutlined', RocketOutlined)
    app.component('SafetyCertificateOutlined', SafetyCertificateOutlined)
    app.component('SafetyOutlined', SafetyOutlined)
    app.component('SaveOutlined', SaveOutlined)
    app.component('ScheduleOutlined', ScheduleOutlined)
    app.component('ScanOutlined', ScanOutlined)
    app.component('ScissorOutlined', ScissorOutlined)
    app.component('SearchOutlined', SearchOutlined)
    app.component('SettingOutlined', SettingOutlined)
    app.component('ShareAltOutlined', ShareAltOutlined)
    app.component('ShoppingOutlined', ShoppingOutlined)
    app.component('StopOutlined', StopOutlined)
    app.component('SwapOutlined', SwapOutlined)
    app.component('SyncOutlined', SyncOutlined)
    app.component('TagOutlined', TagOutlined)
    app.component('TeamOutlined', TeamOutlined)
    app.component('ThunderboltOutlined', ThunderboltOutlined)
    app.component('ToolOutlined', ToolOutlined)
    app.component('TranslationOutlined', TranslationOutlined)
    app.component('UndoOutlined', UndoOutlined)
    app.component('UsbOutlined', UsbOutlined)
    app.component('UserAddOutlined', UserAddOutlined)
    app.component('UserDeleteOutlined', UserDeleteOutlined)
    app.component('UsergroupDeleteOutlined', UsergroupDeleteOutlined)
    app.component('UserOutlined', UserOutlined)
    app.component('UserSwitchOutlined', UserSwitchOutlined)
    app.component('UploadOutlined', UploadOutlined)
    app.component('VerticalAlignBottomOutlined', VerticalAlignBottomOutlined)
    app.component('VerticalAlignTopOutlined', VerticalAlignTopOutlined)
    app.component('WarningOutlined', WarningOutlined)
    app.component('WifiOutlined', WifiOutlined)
    app.component('renderIcon', renderIcon)
    app.component('SolutionOutlined', SolutionOutlined)
  }
}
